import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpErrorInterceptor } from './interceptor-error.interceptor';
import { HttpTimeoutInterceptor } from './interceptor-timeout.interceptor';

/**
 * @description Http Interceptor.
 * @exports
 * @class HttpInterceptorModule
 */
@NgModule({
  imports: [BrowserModule],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTimeoutInterceptor,
      multi: true
    }
  ]
})
export class HttpInterceptorModule {}
